import styled from 'styled-components';
import { unit } from '../../styles/unit';
import { createPropTypes, space } from '../../styles/system';
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1jmnhsg-0"
})(["width:100%;max-width:", ";", ""], unit(341.5), space.withDefaults({
  mx: 'auto',
  px: [3, 6]
}));
Container.propTypes = Object.assign({}, createPropTypes(space.propNames));
export { Container };